import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Card, Spinner, Button, Table, Col, Row, Alert } from 'react-bootstrap';
import { FaEdit, FaTrash, FaPlus, FaEye, FaArrowLeft } from 'react-icons/fa';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { getAllStopSale } from "./stopsaleAction";
import $ from 'jquery';
import moment from 'moment'
import Swal from 'sweetalert2'
import Tooltip from '@mui/material/Tooltip';
import { getSRolePermission } from '../userRolePermission/rolepermissionAction';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import Button1 from '@mui/material/Button';

const StopSaleList2 = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id }  = useParams();
    const { name }  = useParams();
    const firstUpdate = useRef(true);
   

    useEffect(() => {
        dispatch(getSRolePermission());
        
    }, []);
  
    const { permissionisLoading, combinedrolepermissiondetails } = useSelector(
        (state) => state.rolePermissionList
      );

      const filteredPermissions = combinedrolepermissiondetails.filter(
        (item) => item.label === "Add Stop Sale"
      );
      let menu_view = 0;
      let menu_add = 0;
      let menu_edit = 0;
      let menu_delete = 0;
      
      if (filteredPermissions.length > 0) {
        const permission = filteredPermissions[0];
        menu_view = permission.menu_view;
        menu_add = permission.menu_add;
        menu_edit = permission.menu_edit;
        menu_delete = permission.menu_delete;
      }

    const onSubProductStopSaleSingle = (idd, name2,e) => {
        e.preventDefault();
       navigate('/stopsaleList3/' + id + "/" + idd + "/" + name+ "/" + name2); 
    }
   
    useLayoutEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
            dispatch(getAllStopSale());
           
        }
    },[]);
    useEffect(() => {
        dispatch(getAllStopSale());
        
    }, []);

    const stopsaleList2  = useSelector((state) => state.stopsaleList?.stopsale?.stopsaleList2 || []);
    console.log("sjjjjjjj",stopsaleList2)




    // if (pisLoading) {
    //     return (
    //         <>
    //             <Container className="my-4 mx-4 container-xl justify-content-center">
    //                 <h2>Loading.....</h2>

    //             </Container>
    //         </>
    //     );
    // }
    // if (products.length === 0) {
    //     return (
    //         <>
    //             <Container className="my-4 mx-4 container-xl">
    //                 <div style={{ display: 'flex', justifyContent: 'flex-start',marginLeft:'130px',marginRight:'-100px' }}><Link className="btn alink btncolorb" variant="btncolorb" to="/createStopSale"><FaPlus className='fwcolor' /> Add Stop Sale</Link>{' '}</div>
    //             </Container>
    //             <Container className="my-4 mx-4 container-xl">
    //                 <h2 style={{marginLeft:'130px',marginRight:'-100px'}}>No Product to display.....</h2>

    //             </Container>
    //         </>
    //     );
    // }

    const renderedProduct = stopsaleList2.filter(obj => obj.product_id == id).map((product, index) => (
        
        <tr key={product.id}>
            <td>{index+ 1}</td>
            <td>{product.subproduct_name}</td>
            <td className="tdstyle" style={{width:'107px'}}><>
            {menu_view===1 &&(<Tooltip title="View Stop Sale"><Button className="btn btn-sm btn-primary"  onClick={(e) => onSubProductStopSaleSingle(product.subproduct_id,product.subproduct_name,e)}  id={product.id} ><FaEye className='fwcolor' /></Button></Tooltip>)}</></td>
        </tr>
    ))

    
    const onProductDelete = (id, e) => {
        // e.preventDefault();
        // Swal.fire({
        //     title: 'Are you sure want to delete the product?',
        //     showDenyButton: true,
        //     icon:'error',
        //     showCancelButton: true,
        //     confirmButtonText: 'Yes',
        //     denyButtonText: 'No',
        //     customClass: {
        //       actions: 'my-actions',
        //       cancelButton: 'order-1 right-gap',
        //       confirmButton: 'order-2',
        //       denyButton: 'order-3',
        //     }
        //   }).then((result) => {
        //     if (result.isConfirmed) {
        //         dispatch(productDeletion(id)).then(() => {
        //             dispatch(getAllStopSale()); 
        //           Swal.fire('product Deleted Successfully!', '', 'success');
        //         })
        //     }
            // if (result.isConfirmed) {
            //     dispatch(productDeletion(id));
            //     dispatch(getAllProduct());
            //     navigate('/productList');
            //     getAllProduct();
               
                  
            //   Swal.fire('Product Deleted Successfully!', '', 'success')
            // }
        //      else if (result.isDenied) {
        //       Swal.fire('Changes are not saved', 'Your Data is safe', 'info')
        //     }
        //   })
 

    }

    const onProductModify = (id, e) => {
        e.preventDefault();
       navigate('/modifyProduct/' + id); 
   }


    //initialize datatable
    $(document).ready(function () {
        setTimeout(function () {
            if ($.fn.dataTable.isDataTable('#example')) {
                const table = $('#example').DataTable();
            }
            else {
                const table = $('#example').DataTable({
                    paging: true,
                    pagingType: 'full_numbers',
                    pageLength: 5,
                    processing: true,
                    dom: 'Bfrtip',
                    buttons: ['csv', 'print'],
                    destroy: true,

                });
            }

        },
            1000
        );
    });
    return (
        <>

            <div className="my-4  container-xl">
                <div className="card" style={{marginTop:'-80px'}}>
                    <div className="card-header">
                        <h3 className="d-flex text-dark text-left mt-2 mb-2"   style={{fontFamily:'Times New Roman' , fontWeight:'600'}}>Stop Sale List</h3>
                        {/* {menu_add===1 &&(<div style={{ display: 'flex', justifyContent: 'flex-start' }}><Link className="btn alink btncolorb" variant="btncolorb" to="/createStopSale"><FaPlus className='fwcolor' /> Add Stop Sale</Link>{' '}</div>)} */}
                        {menu_add===1 &&(<Button1 variant="contained" onClick={() => navigate('/createStopSale')}  color="success" style={{ width: '', float: '', backgroundColor: '#d1af2b', fontSize: '10px'}} startIcon={<AddCircleOutlineIcon />}>
                        Add Stop Sale
                        </Button1>)}
                    </div>
                    <div className="card-body">
                        <Row>
                        <Link to="/stopsaleList"><span className="badge bg-success" style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></Link> <center><span className="badge bg" style={{backgroundColor:'rgb(156 186 237)',color:'black'}}>Product Name: {name}</span></center>
   
                        </Row>
                        <br />
                        {stopsaleList2?.length
                            ? (
                                <table id="example" className="table table-hover table-bordered display" style={{ "width": "100%" }}>
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Sub Product Name</th>
                                          
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {renderedProduct}


                                    </tbody>
                                </table>
                            ) : <p>No Products to display</p>
                        }

                    </div>
                </div>
            </div>

        </>
    )
}

export default StopSaleList2
